import { createSelector } from 'reselect';
import sysUtils from 'utils/ShopYourStore';

import { showShopYourStoreNewAndBestAbTestSelector } from 'viewModel/selectors/testTarget/showShopYourStoreNewAndBestAbTestSelector';

const isShopYourStoreNewAndBestEnabledSelector = createSelector(showShopYourStoreNewAndBestAbTestSelector, showShopYourStoreNewAndBestAbTest => {
    const globalKillswitch = sysUtils.shopYourStoreNewBestEnabled();
    const isShopYourStoreNewAndBestEnabled = globalKillswitch && showShopYourStoreNewAndBestAbTest;

    return isShopYourStoreNewAndBestEnabled;
});

export { isShopYourStoreNewAndBestEnabledSelector };
